// extracted by mini-css-extract-plugin
export default {"form-consent-label":"FormConsentCheckbox_form-consent-label__-dSWh","form-custom-checkbox":"FormConsentCheckbox_form-custom-checkbox__W3zzH"};